module.exports = __webpack_public_path__ + "static/media/dtj-mockup-6.b30b99a1.jpg";